import './vendor';
import vars from './helpers';
// import './components/social';
import Swiper from 'swiper';
import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';
import {actualYear} from './modules/actualYear';
import header from './components/header';
import lazyLoading from './modules/lazyLoading';
import scrollToAnchor from './modules/scrollToAnchor';
import './components/game';
import game from './components/game';

ieFix();
vhFix();
actualYear();
scrollToAnchor.init();

header.init();
lazyLoading.init();

if (vars.isMobile()) {
	if ($('.home__grid .swiper').length) {
		const homeGrid = new Swiper($('.home__grid .swiper')[0], {
			slidesPerView: 'auto',
			spaceBetween: 15,
		});
	}
}

$('.home__intro__button.for-mobile a').on('click', (e) => {
	e.preventDefault();
	vars.$html.addClass('is-show-route');
});

$('.home__route__close').on('click', (e) => {
	e.preventDefault();
	vars.$html.removeClass('is-show-route');
	$('.home__route').removeClass('is-show-game');
	$('.home__route__game').html('');
	game.destroy();
});

$('.home__route__item').on('click', (e) => {
	e.preventDefault();
	// $('.home__route__game').attr('src', $(e.currentTarget).attr('href'));

	$.ajax({
		type: 'get',
		url: `./${$(e.currentTarget).data('type')}-ajax.html`,
		success(response) {
			$('.home__route__game').html(response);
			$('.home__route').addClass('is-show-game');
			game.init();
			window._goodshare.reNewAllInstance();
		},
	});
});
